import { createTheme } from '@mui/material';

const FONT = "'Montserrat', sans-serif";
const POPUP = {
  borderRadius: 8,
  boxShadow: '0 4px 16px var(--shadow-color), 0 0 0 1px var(--light-secondary-color)',
};

/**
 * Тема MUI в духе Яндекс Трекера: плотные поля 32px, кнопки без капса и теней, мягкие всплывающие окна.
 * Подключена в трекере (TrackerLayout) и на экранах нового учёта (/v2/*); legacy-экраны таймлога — без неё
 */
export const appTheme = createTheme({
  typography: {
    fontFamily: FONT,
    fontSize: 13,
    button: { textTransform: 'none', fontWeight: 500 },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 8 } },
    },
    MuiIconButton: {
      styleOverrides: {
        root: { borderRadius: 8, color: 'var(--dark-secondary-color)' },
        sizeSmall: { padding: 4 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: 13,
          backgroundColor: 'var(--main-color)',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--secondary-hover-color)' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--secondary-color)' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: 1,
            borderColor: 'var(--accent-color)',
          },
          '&.Mui-focused': { boxShadow: '0 0 0 3px var(--very-light-accent-color)' },
          '&.Mui-error .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--danger-color)' },
        },
        // 32px — высота полей в Яндекс Трекере
        inputSizeSmall: { paddingTop: 7, paddingBottom: 7 },
        multiline: { paddingTop: 7, paddingBottom: 7 },
      },
    },
    MuiInputLabel: { styleOverrides: { root: { fontSize: 13 } } },
    MuiFormHelperText: { styleOverrides: { root: { marginLeft: 2, fontSize: 12 } } },
    MuiInputAdornment: { styleOverrides: { root: { color: 'var(--secondary-color)' } } },
    MuiAutocomplete: {
      styleOverrides: {
        paper: { ...POPUP, marginTop: 4 },
        listbox: { padding: 4 },
        option: { minHeight: 32, borderRadius: 6, fontSize: 13 },
        inputRoot: { '&.MuiInputBase-sizeSmall': { paddingTop: 3, paddingBottom: 3 } },
      },
    },
    MuiPopover: { styleOverrides: { paper: POPUP } },
    MuiMenu: { styleOverrides: { list: { padding: 4 } } },
    MuiMenuItem: {
      styleOverrides: { root: { minHeight: 32, borderRadius: 6, fontSize: 13 } },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: { fontSize: 12, lineHeight: '28px', color: 'var(--secondary-color)' },
      },
    },
    MuiTooltip: {
      defaultProps: { disableInteractive: true },
      styleOverrides: {
        tooltip: {
          padding: '4px 8px',
          borderRadius: 6,
          fontSize: 12,
          backgroundColor: 'var(--primary-color)',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { fontSize: 13, borderColor: 'var(--light-secondary-color)' },
        head: {
          height: 36,
          paddingTop: 0,
          paddingBottom: 0,
          fontWeight: 500,
          whiteSpace: 'nowrap',
          color: 'var(--dark-secondary-color)',
          backgroundColor: 'var(--main-color)',
          // Тень, а не border: у липкого заголовка border пропадает при прокрутке
          borderBottom: 'none',
          boxShadow: 'inset 0 -1px 0 var(--light-secondary-color)',
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          '&:hover, &:focus': { color: 'var(--primary-color)' },
          '&.Mui-active': { color: 'var(--primary-color)' },
        },
        icon: { fontSize: 16, color: 'var(--secondary-color) !important' },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.MuiTableRow-hover:hover': { backgroundColor: 'var(--very-light-secondary-color)' },
        },
      },
    },
    MuiChip: { styleOverrides: { root: { borderRadius: 6, fontSize: 12 } } },
    MuiSwitch: { defaultProps: { size: 'small' } },
    MuiFormControlLabel: { styleOverrides: { label: { fontSize: 13 } } },
  },
});
